// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap---KJ7Hh","title":"title---EwIT2"};